const QuickExit = () => {
  const exit = document.querySelector(".quick-exit");

  if (!exit) {
    return;
  }

  const url =
    document.querySelector(".quick-exit__exit").getAttribute("href") ??
    "https://www.google.com";

  const quick = document.querySelector(".quick-exit--triggered");

  window.addEventListener("popstate", (event) => {
    if (event.state && event.state.isBackPage) {
      document.body.style = "opacity: 0;";
      document.body.classList.add("quick-exit--triggered");
      document.title = url;
      window.location.href = url;
    }
  });

  if (quick || window.location.search.includes("qe=1")) {
    document.body.style = "opacity: 0;";
    document.body.classList.add("quick-exit--triggered");
    document.title = url;
    window.location.href = url;

    return;
  }

  // clicking the entire quick-exit takes you to the exit url as long as you
  // don't click the quick-exit__button button
  exit.addEventListener("click", (e) => {
    if (
      e.target.classList.contains("quick-exit__button") ||
      e.target.closest(".quick-exit__button")
    ) {
      return;
    }

    e.preventDefault();

    // update the page title tag
    document.title = url;
    document.body.style = "opacity: 0;";
    document.body.classList.add("quick-exit--triggered");

    window.history.replaceState(
      { isBackPage: false },
      "<name>",
      window.location.origin + window.location.pathname + "?qe=1"
    );

    // push 100 history states to prevent back button
    for (let i = 0; i < 20; i++) {
      window.history.pushState(
        { isBackPage: true },
        "<website>",
        window.location.origin + window.location.pathname + "?qe=1"
      );
    }

    window.location.href = url;

    return false;
  });

  let animating = false;
  exit.querySelector(".quick-exit__button").addEventListener("click", () => {
    if (animating) {
      return;
    }

    animating = true;

    if (exit.classList.contains("quick-exit--minimised")) {
      exit.classList.add("quick-exit--hidden");

      setTimeout(() => {
        // we're making it big!
        exit.classList.remove("quick-exit--minimised");

        // save state to local storage
        localStorage.setItem("quick-exit-minimised", "false");

        setTimeout(() => {
          exit.classList.add("quick-exit--show-text");
          exit.classList.remove("quick-exit--hidden");
          animating = false;
        }, 400);
      }, 400);
    } else {
      // we're making it small!
      exit.classList.remove("quick-exit--show-text");

      localStorage.setItem("quick-exit-minimised", "true");

      setTimeout(() => {
        // allow animation to finish
        exit.classList.add("quick-exit--minimised");
        animating = false;
      }, 200);
    }
  });

  // check local store for state
  if (localStorage.getItem("quick-exit-minimised") === "true") {
    exit.classList.add("quick-exit--minimised");
  }

  setTimeout(() => {
    // allow animation to finish
    exit.classList.remove("quick-exit--hidden");
    exit.classList.toggle("quick-exit--show-text");
  }, 600);
};

export default QuickExit;
